exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".inScadenza {\n\tcolor: red;\n\tfont-weight: bold;\n}\n\n.scaduto {\n\tcolor: #aaa;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.css
// module id = 344
// module chunks = 0